import { render, staticRenderFns } from "./RecommendationBox.vue?vue&type=template&id=c989a254"
import script from "./RecommendationBox.vue?vue&type=script&lang=js"
export * from "./RecommendationBox.vue?vue&type=script&lang=js"
import style0 from "./RecommendationBox.vue?vue&type=style&index=0&id=c989a254&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports